import { render } from "./busquedaavanzada.vue?vue&type=template&id=5754300e&scoped=true"
import script from "./busquedaavanzada.vue?vue&type=script&lang=js"
export * from "./busquedaavanzada.vue?vue&type=script&lang=js"

import "./busquedaavanzada.vue?vue&type=style&index=0&id=5754300e&scoped=true&lang=css"

import exportComponent from "C:\\paginascedis\\general\\cedispage2.0_general_vipla\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5754300e"]])

export default __exports__